import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IDateBuilder from "../../../../toolkit/baseForms2/iDateBuilder/IDateBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "fechaBaja";
export type Buttons = "aceptar" | "cancelar";

export const bajaFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "fechaBaja",
      label: "Fecha de Baja",
      bts: { mCol: 12 },
      component: IDateBuilder,
      props: {}
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Confirmar Baja",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: { color: "danger" }
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: {}
    }
  ],
  validations: {
    fechaBaja: {
      required: true
    }
  },
  rows: [["fechaBaja"], ["aceptar", "cancelar"]]
};
